import { PRIMITIVE_METADATA } from '../config/primitiveMetadata';
import { PRIMITIVE_RELATIONSHIPS } from '../config/primitiveRelationships';
import { DOMAIN_CATALOG } from '@unwritten/domain-registry';
import { HelpCircle } from 'lucide-react';
/**
 * Get metadata for any domain (core or non-core)
 */
function getDomainMetadata(domainId) {
    if (domainId in PRIMITIVE_METADATA) {
        return PRIMITIVE_METADATA[domainId];
    }
    const domain = DOMAIN_CATALOG.find((d) => d.id === domainId);
    if (domain) {
        return {
            id: domain.id,
            name: domain.name,
            color: '#94A3B8',
            icon: HelpCircle,
        };
    }
    return {
        id: domainId,
        name: domainId,
        color: '#94A3B8',
        icon: HelpCircle,
    };
}
/**
 * Converts primitive relationships into graph data format
 *
 * This uses the PRIMITIVE_RELATIONSHIPS configuration to build a graph
 * showing how primitives are connected in the schema.
 */
export function schemaToGraphData() {
    const nodes = [];
    const edges = [];
    const addedNodes = new Set();
    Object.entries(PRIMITIVE_RELATIONSHIPS).forEach(([sourceType, relationships]) => {
        const source = sourceType;
        if (!addedNodes.has(source)) {
            const meta = PRIMITIVE_METADATA[source];
            nodes.push({
                id: source,
                type: source,
                label: meta.name,
                properties: { type: 'schema' },
                color: meta.color,
                size: 12,
            });
            addedNodes.add(source);
        }
        relationships.forEach((rel, idx) => {
            const target = rel.targetPrimitive;
            if (!addedNodes.has(target)) {
                const meta = getDomainMetadata(target);
                nodes.push({
                    id: target,
                    type: target,
                    label: meta.name,
                    properties: { type: 'schema' },
                    color: meta.color,
                    size: 10,
                });
                addedNodes.add(target);
            }
            edges.push({
                id: `${source}-${target}-${idx}`,
                source,
                target,
                type: rel.fieldType,
                label: rel.field,
                metadata: {
                    relationshipType: rel.relationshipType,
                    description: rel.description,
                },
            });
        });
    });
    return { nodes, edges };
}
